export const strings_de = {
  lang: 'de',
  fallbackTenant: 'tagesanzeiger',
  mapTitle: 'Anzahl Einwohner:innen pro Hektar',
  search: 'Suche',
  activateMap: 'Karte aktivieren',
  deactivateMap: 'Karte deaktivieren',
  noResults: 'Keine Ergebnisse gefunden',
  noGeolocation: 'Ortung nicht erlaubt.',
  squareTitle: 'Anzahl Einwohner:innen',
  compareA: <>wohnen in der Schweiz noch weniger dicht pro km²</>,
  compareB: <>wohnen in der Schweiz noch dichter pro km²</>,
  histoTitle: 'Anzahl Personen nach Bevölkerungsdichte',
  histoLabelVert: ['Einwohner', ' pro km2'],
  histoLabelHori: 'Anzahl Personen',
  lessThanOne: 'weniger als 1',
  evaluationText: [
    'Im ausgewählten Hektar',
    'wohnen',
    'Personen. Rundherum, innerhalb eines Quadratkilometers',
    'sind es',
    'in der Schweiz wohnen',
    'noch dichter',
  ],
}
